
import { Component, Input } from '@angular/core';

import * as Objects from '@core/objects';


import { ProjectLogbookEventList } from '@app/models/logbook-events.model';
@Component({
    selector: 'project-details-logbook-event-user-on-properties',
    templateUrl: './user-on-properties.component.html',
    styleUrls: ['./user-on-properties.component.scss']
})
export class ProjectDetailsLogbookEventUserOnPropertiesComponent {
    public readonly EVENT_TRACK_REFERENCE = Objects.EventTrackReference;

	@Input() event: Objects.LogbookEvent;
    @Input() properties: any = null;
    
    getReference(){
        const eventTrack =  ProjectLogbookEventList.find((et: Objects.EventTrack) => this.event.type == et.id);
        return eventTrack ? eventTrack.reference : '';
    }
}